"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { getCookieConsent, setCookieConsent } from "@/lib/cookie-consent";

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(getCookieConsent() === null);
  }, []);

  if (!visible) return null;

  const handleChoice = (value: "accepted" | "rejected") => {
    setCookieConsent(value);
    setVisible(false);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-[#e4e4e7] bg-white px-4 py-4 shadow-[0_-4px_16px_rgba(0,0,0,0.08)] sm:px-6">
      <div className="mx-auto flex max-w-6xl flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-[#18181b]">
          Koristimo kolačiće za rad stranice te, uz vaš pristanak, za analitiku
          posjećenosti (Google Analytics). Više informacija potražite u našoj{" "}
          <Link
            href="/politika-privatnosti"
            className="font-medium underline underline-offset-2 hover:text-[#71717a]"
          >
            Politici privatnosti i kolačića
          </Link>
          .
        </p>
        <div className="flex flex-shrink-0 items-center gap-3">
          <button
            type="button"
            onClick={() => handleChoice("rejected")}
            className="rounded-full border border-[#E4E4E7] bg-white px-4 py-2 text-sm font-medium text-[#18181b] hover:bg-[#F4F4F5] transition-colors"
          >
            Odbij
          </button>
          <button
            type="button"
            onClick={() => handleChoice("accepted")}
            className="rounded-full bg-[#FDE047] px-4 py-2 text-sm font-semibold text-[#18181b] hover:bg-[#FACC15] transition-colors"
          >
            Prihvati
          </button>
        </div>
      </div>
    </div>
  );
}
